module.exports = __webpack_public_path__ + "static/media/island_grey.50b0c66d.webp";